import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import client from 'api'

const initialState = {
    tenants: [],
    suppliers: [],
    users: [],
    owners: [],

    status: 'idle',
    error: undefined as string | undefined,
}

// thunks
export const loadReporters = createAsyncThunk('reporters/loadReporters', async (typeId: number, thunkApi) => {
    const res = await client.get(`/api/ixweb/reporters/${typeId}/`)

    switch(typeId) {
        case 1: return { tenants: res.data }
        case 2: return { suppliers: res.data }
        case 3: return { users: res.data }
        case 4: return { owners: res.data }
        default: thunkApi.rejectWithValue('Unknown reporter type id')
    }
})

// slice
const reportersSlice = createSlice({
    name: 'reporters',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(loadReporters.pending, (state) => {
            state.status = 'pending'
            state.error = undefined
        })

        builder.addCase(loadReporters.fulfilled, (state, action) => {
            return {
                ...state,
                status: 'idle',
                error: undefined,
                ...action.payload
            }
        })

        builder.addCase(loadReporters.rejected, (state, action) => {
            state.status = 'error'
            state.error = action.error.message
        })
    }
})


export default reportersSlice.reducer
